/**
 * Booth OS · shell atoms.
 *
 * Identical to the atoms previously inlined inside `BoothOSPage.js`.
 * Kept SEPARATE from the existing `primitives.js` because the
 * BoothOSPage shell uses larger defaults (lg Heading, 620 maxWidth
 * Lede, etc.) and museum-conservation discipline forbids any
 * visual drift during the structural refactor.
 *
 * Do not "improve" or merge with primitives.js — that's a future
 * decision, not a refactor decision.
 */
import React from 'react';

export const SERIF = 'Georgia, "Times New Roman", serif';
export const MAX_MESSAGE = 120;

export const Eyebrow = ({ theme, children }) => (
  <div style={{
    fontFamily: SERIF, fontWeight: 800,
    fontSize: 12, letterSpacing: '0.32em', textTransform: 'uppercase',
    color: theme.gold, marginBottom: 18,
  }}>{children}</div>
);

export const Heading = ({ theme, children, size = 'lg' }) => (
  <h1 style={{
    fontFamily: SERIF, fontWeight: 500,
    fontSize: size === 'lg' ? 'clamp(36px, 5.4vw, 64px)' : 'clamp(26px, 4vw, 40px)',
    lineHeight: 1.08, letterSpacing: '-0.012em',
    color: theme.ink, margin: 0,
  }}>{children}</h1>
);

export const Lede = ({ theme, children, center = true }) => (
  <p style={{
    fontFamily: SERIF, fontStyle: 'italic',
    fontSize: 'clamp(15px, 1.4vw, 18px)',
    color: theme.inkMuted, lineHeight: 1.55,
    margin: '14px 0 0', maxWidth: 620,
    textAlign: center ? 'center' : 'left',
    marginLeft: center ? 'auto' : 0,
    marginRight: center ? 'auto' : 0,
  }}>{children}</p>
);

export const CenteredCopy = ({ theme, children }) => (
  <div style={{
    minHeight: '100vh',
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    padding: 'clamp(40px, 8vw, 80px) 24px',
    textAlign: 'center',
  }}>{children}</div>
);

export const GoldPill = ({ theme, onClick, children, large, secondary, testId, style }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    style={{
      padding: large ? '18px 32px' : '14px 24px',
      borderRadius: 999,
      border: 'none',
      background: secondary
        ? 'transparent'
        : `linear-gradient(135deg, ${theme.gold} 0%, ${theme.goldDeep} 100%)`,
      color: secondary ? theme.ink : '#0F0B1A',
      fontFamily: SERIF, fontWeight: secondary ? 500 : 700,
      fontStyle: secondary ? 'italic' : 'normal',
      fontSize: large ? 18 : 15,
      letterSpacing: '0.02em',
      cursor: 'pointer',
      boxShadow: secondary ? 'none' : '0 10px 30px rgba(0,0,0,0.42)',
      transition: 'transform 220ms ease, background 220ms ease',
      ...(secondary ? { border: `1px solid ${theme.hair}` } : {}),
      ...style,
    }}
    onPointerDown={(e) => { e.currentTarget.style.transform = 'translateY(1px)'; }}
    onPointerUp={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
    onPointerLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
  >
    {children}
  </button>
);
